import { createAction } from 'redux-actions';

export const CHANGE_INPUT = 'CHANGE_INPUT';

export const changeInput = createAction(CHANGE_INPUT);
